import {Component, Input, OnInit} from '@angular/core';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {
  SolicitudUnidadCreditoUnidadProductivaService,
} from '../../../../../_services/solicitud-unidad-credito-unidad-productiva.service';
import {
  TercerosUPActividadesEconomicasVersionesService,
} from '../../../../../_services/terceros-UPActividades-economicas-versiones.service';
import {AdmsbUnidadProductivaVista} from '../../../../../_models/admsb-titular';
import {extraerCiudad, formatearActividadEconomica} from '../../admsb-titular.helpers';

@Component({
  selector: 'app-admsb-unidad-productiva',
  templateUrl: './admsb-unidad-productiva.component.html',
  styleUrls: ['./admsb-unidad-productiva.component.scss'],
})
export class AdmsbUnidadProductivaComponent implements OnInit {

  /** Identificador de la solicitud de unidad de crédito */
  @Input() idSolicitudUCUnidadProductiva: string;

  cargandoUnidadProductiva = true;

  unidadProductiva: AdmsbUnidadProductivaVista = {
    nombreNegocio: '',
    telefonoEstablecimiento: '',
    direccion: '',
    ciudad: '',
    actividadEconomica: '',
  };

  constructor(
    private solUnidadCreditoUPServicio: SolicitudUnidadCreditoUnidadProductivaService,
    private terUpActividadesEconomicasServicio: TercerosUPActividadesEconomicasVersionesService,
  ) {
  }

  ngOnInit(): void {
    if (this.idSolicitudUCUnidadProductiva) {
      this.cargarUnidadProductiva(this.idSolicitudUCUnidadProductiva);
    } else {
      this.cargandoUnidadProductiva = false;
    }
  }

  private cargarUnidadProductiva(idSolicitudUCUnidadProductiva: string): void {
    this.solUnidadCreditoUPServicio.obtener(idSolicitudUCUnidadProductiva).pipe(
      switchMap(res => this.terUpActividadesEconomicasServicio
        .listadoPorUnidadProductivaHabilitado(res.idTerceroUnidadProductiva)
        .pipe(
          map(actividades => ({res, actividadEconomica: formatearActividadEconomica(actividades[0])})),
          catchError(() => of({res, actividadEconomica: undefined})),
        ),
      ),
    ).subscribe({
      next: ({res, actividadEconomica}) => {
        this.unidadProductiva = {
          nombreNegocio: res.nombre,
          telefonoEstablecimiento: res.telefonoFijo,
          direccion: res.direccion,
          ciudad: extraerCiudad(res.direccion),
          actividadEconomica,
        };
        this.cargandoUnidadProductiva = false;
      },
      error: () => this.cargandoUnidadProductiva = false,
    });
  }

}
